
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Field, Form } from "vee-validate";
import * as yup from "yup";
import { AuthApi } from "../../autogen";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import FieldLabel from "../atoms/FieldLabel.vue";
import ChangePassword from "../organisms/ChangePassword.vue";
import FormMixin from "../../helpers/mixins/form";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  username: string;
  confirmationCode: string;
  password: string;
};
@Options({
  components: { Form, Field, FieldError, FormError, ChangePassword, FieldLabel, ActionButton }
})
export default class ResetPassword extends FormMixin {
  globalErrors: { message: string }[] = [];
  @Prop({ type: String }) usernamea!: string;
  formValues: FormValues = {
    username: this.usernamea,
    confirmationCode: "",
    password: ""
  };
  inputLock = true;
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      await new AuthApi().confirmForgotPassword({
        confirmForgotPasswordRequest: values
      });
      this.$router.push("/login");
    });
  }
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup.string().required(this.$t("input_required", { field: "ユーザーID" })),
      confirmationCode: yup.string().required(this.$t("input_required", { field: "認証コード" })),
      password: yup.string().required(this.$t("input_required", { field: "パスワード" }))
    });
  }
  onGoLogin() {
    this.$router.push("/login");
  }
}
